<template>
  <div :class="'dashboard reviews'+(!project.active?' disabled':'')" v-if="loaded">
    <div class="navbar">
      <div class="left">
        <div class="title">
          <div class="wrap">
            <h4>Настройки проекта</h4>
            <div class="sub-title">Управление параметрами сбора и анализа отзывов</div>
          </div>
        </div>

        <div class="end-area">
        </div>
      </div>
      <TopBlock :noData="true"></TopBlock>
    </div>

    <div class="setting-block" v-if="is_owner">
      <div class="title-block">Ссылки для мониторинга</div>
      <div class="inner">
        <LinkSettings
            :groups="reportGroups"
            @group-created="addNewGroup"
        />
        <ProjectAutoReply v-if="$store.getters.tariff.has_auto_replay"></ProjectAutoReply>
        <MarkerSettings></MarkerSettings>
        <TagSettings></TagSettings>

      </div>
    </div>

    <div class="setting-block">
      <div class="title-block">Проект</div>
      <div class="inner">
        <div class="card shadow mt-2 mb-3 border-0" v-if="is_owner">
          <div class="card-body">
            <div class="title">
              <div>
                <h5>Название проекта</h5>
                <div class="sub-title">Имя вашей организации или проекта</div>
              </div>
            </div>
            <form @submit.prevent="saveProject" class="row mb-3 align-items-center">
              <div class="col">
                <div class="form-floating">
                  <input id="name" class="form-control" required v-model="settings.name" placeholder="Название">
                  <label for="name">Название</label>
                </div>
              </div>
              <div class="col-lg-2">
                <button class="btn btn-primary" type="submit">Сохранить</button>
              </div>

            </form>


            <div class="row">
              <div v-if="project.active">
                <button @click="$modal('show', 'stop_project')" class="col-2 btn btn-danger ms-auto brn-sm">Остановить
                </button>
                <div class="col sub-title">Отключает сбор и анализ данных для проекта</div>
              </div>
              <div v-else>
                <button @click="settings.active = true; saveProject();" class="col-2 btn btn-success ms-auto brn-sm">
                  Восстановить
                </button>
                <div class="col sub-title">Включает сбор и анализ данных для проекта</div>
              </div>
            </div>

          </div>
        </div>
        <ProjectAlertSettings></ProjectAlertSettings>
        <ParserSettings v-if="is_owner"></ParserSettings>


      </div>
    </div>

    <div class="setting-block" v-if="is_owner">
      <div class="title-block">Отчеты</div>
      <div class="inner">
        <ReportGroupsSettings
            :projectId="project_id"
            @update:groups="handleGroupsUpdate"
        />

      </div>
    </div>

    <div class="setting-block" v-if="is_owner">
      <div class="title-block">Пользователи</div>
      <div class="inner">
        <UsersPermission></UsersPermission>

      </div>
    </div>
    <DeleteProject v-if="is_owner"></DeleteProject>
    <modal modal_id="stop_project" v-if="is_owner">
      <template v-slot:header>
        <h4>Остановить проект</h4>
      </template>
      <template v-slot:body>

        <h6><strong>Вы уверены, что хотите остановить мониторинг проекта?</strong></h6>
        <p>Сборы данных по расписанию и анализ данных будут остановлены</p>

      </template>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="$modal('hide', 'stop_project')"
                data-bs-dismiss="modal">Закрыть
        </button>
        <button type="button" class="btn btn-danger"
                @click="settings.active = false; saveProject();$modal('hide', 'stop_project');"
                data-bs-dismiss="modal">Остановить
        </button>
      </template>
    </modal>

  </div>


</template>

<script>

import LinkSettings from "@/views/project/components/LinkSettings.vue";
import ReportGroupsSettings from "@/views/project/components/ReportGroupsSettings.vue";
import DeleteProject from "@/views/project/components/DeleteProject.vue";
import ParserSettings from "@/views/project/components/ParserSettings.vue";
import MarkerSettings from "@/views/project/components/MarkerSettings.vue";
import TagSettings from "@/views/project/components/TagSettings.vue";
import {ProjectApi} from "@/api/projects";
import TopBlock from "@/components/TopBlock.vue";
import UsersPermission from "@/views/project/components/UsersPermission.vue";
import ProjectAlertSettings from "@/views/project/components/ProjectAlertSettings.vue";
import ProjectAutoReply from "@/views/project/components/ProjectAutoReply.vue";

export default {
  name: 'ProjectSettings',
  data() {
    return {
      loaded: false,
      settings: {},
      reportGroups: []
    }
  },
  components: {
    ProjectAutoReply,
    ProjectAlertSettings,
    UsersPermission, TopBlock, TagSettings, LinkSettings,
    ParserSettings, MarkerSettings, ReportGroupsSettings, DeleteProject
  },
  watch: {
    "settings.email_alert"(newVal, oldVal) {
      if (oldVal !== undefined && newVal !== oldVal) this.saveProject()
    },
    "settings.tg_alert"(newVal, oldVal) {
      if (oldVal !== undefined && newVal !== oldVal) this.saveProject()
    }
  },
  computed: {
    is_owner() {
      if (this.$store.getters.currentProject.id && this.$store.getters.user.id) return this.$store.getters.currentProject.user_id === this.$store.getters.user.id
      else return false
    },
    user: {
      get() {
        return this.$store.getters.user
      },
      set(value) {
        this.$store.dispatch('update_user', value)
      }
    },
    project_id: {
      get() {
        return this.$store.getters.currentProjectId
      },
      set(value) {
      }
    },
    project: {
      get() {
        return this.$store.getters.currentProject
      },
      set(value) {
      }
    }
  },
  beforeCreate() {
    // if (this.$store.getters.currentProject.user_id !== this.$store.getters.user.id) location.pathname = '/'
  },
  mounted: function () {
    this.loaded = true;
    if (this.is_owner) ProjectApi.get_review_settings(this.project_id).then(response => {
      this.settings = response
    })


  },
  methods: {
    handleGroupsUpdate(groups) {
      this.reportGroups = groups;
    },
    addNewGroup(group) {
      this.reportGroups.push(group);
    },
    saveProject() {
      const $this = this;
      ProjectApi.get_review_settings(this.project_id).then(response => {
        const settings = {
          ...response,
          ...$this.settings
        }
        ProjectApi.save_review_settings(this.project_id, settings).then(() => {
          $this.$notify({
            type: "success",
            text: 'Настройки сохранены'
          })
        })

      });

    }
  }
}

</script>
<style scoped lang="scss">
.setting-block {
  border: 1px solid #eee;
  border-radius: 5px;
  padding: 5px;
  position: relative;
  margin-bottom: 20px;

  .title-block {
    position: absolute;
    top: -12px;
    left: 16px;
    background: #eee;
    border-radius: 5px;
    font-size: 13px;
    padding: 0 3px;
    font-weight: bold;
    border: 1px solid #ccc;
  }
}

</style>
